import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dmsfaq',
  templateUrl: './dmsfaq.component.html',
  styleUrls: ['./dmsfaq.component.css']
})
export class DmsfaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
